require('./dropdownFunds.scss');

const PropTypes = require('prop-types');

const React = require('react');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { formatText } = require('core/i18n').i18n;
const classnames = require('classnames');
const FundItemSelected = require('./fundItemSelected');
const FundItemOptions = require('./fundItemOptions');
const { toCamelCase } = require('utilities/stringHelper');
const PureRenderMixin = require('react-addons-pure-render-mixin');

class DropdownFunds extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { initialFundId, currentFundId } = this.props;
        if (initialFundId && !currentFundId) {
            this.props.onFundChange(initialFundId, true);
        }
    }

    handleChange(item) {
        this.props.onFundChange(item.value);
    }

    render() {
        const { immFunds, currentFundId, enabled, id, error, errorMsg, label, tooltipMsg } = this.props;
        const placeholder = formatText('brokerDropdownFunds-select');
        const searchable = false;
        const clearable = false;

        const options = immFunds.map(immFund => {
            const fund = immFund.toJS();
            return {
                id,
                value: fund.id,
                name: toCamelCase(fund.name || ''),
                totalValue: fund.totalValue,
                totalValueCurrency: fund.totalValueCurrency,
                account: fund.contractNumber
            };
        });
        const className = classnames('dropdown-funds', { 'dropdown-funds--error': error });

        return (
            <OKSelect
                id={id}
                label={label}
                name="form-field-name"
                className={className}
                disabled={!enabled}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                optionComponent={FundItemOptions}
                options={options.toJS()}
                value={currentFundId}
                valueComponent={FundItemSelected}
                searchable={searchable}
                clearable={clearable}
                placeholder={placeholder}
                errorState={error}
                errorMessage={errorMsg}
                tooltipContent={tooltipMsg}
            />
        );
    }
}

DropdownFunds.propTypes = {
    fundIndexes: PropTypes.array,
    currentFundId: PropTypes.string,
    initialFundId: PropTypes.string,
    onFundChange: PropTypes.func,
    enabled: PropTypes.bool,
    filterId: PropTypes.string,
    immFunds: PropTypes.object,
    id: PropTypes.string,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
    label: PropTypes.string,
    tooltipMsg: PropTypes.string
};

DropdownFunds.defaultProps = {
    filterId: '',
    enabled: true,
    errorMsg: '',
    label: ''
};
module.exports = DropdownFunds;